/* eslint-disable no-empty no-empty-pattern */
import Vue from 'vue'
import Vuex from 'vuex'

import adminModule from '@/store/modules/admin'
import authModule from '@/store/modules/auth'
import registrationModule from '@/store/modules/register'
import usersModule from '@/store/modules/users'
import submissionsModule from '@/store/modules/submissions'
import invitesModule from '@/store/modules/invites'
import logsModule from '@/store/modules/logs'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    admin: adminModule,
    auth: authModule,
    register: registrationModule,
    users: usersModule,
    submissions: submissionsModule,
    invites: invitesModule,
    logs: logsModule
  },
  state: {
    selectedTab: 'user',
    events: {},
    currentEvent: {}
  },
  mutations: {
    saveTab: (state, value) => {
      state.selectedTab = value
    },
    saveEvents: (state, value) => {
      state.events = value
    },
    saveEvent: (state, value) => {
      state.currentEvent = value
    }
  },
  getters: {
    tab: state => {
      return state.selectedTab
    },
    events: state => {
      return state.events
    },
    currentEvent: state => {
      return state.currentEvent
    }
  }
})
